<template>
    <div class="goods-form">
        <veui-form
            ref="culeForm"
            :data="formData"
            :validators="validators"
        >
            <veui-field
                name="clue_territory"
                label="线索领域"
                searchable
                :rules="[{name: 'required', value: true, message: '请选择线索领域'}]"
            >
                <veui-select
                    v-model="formData.clue_territory"
                    data-stat-ignore
                    clearable
                    multiple
                    placeholder="请选择线索领域"
                >
                    <veui-option
                        v-for="(item,index) in doaminOption"
                        :key="index"
                        :value="item.value"
                        :label="item.text"
                    />
                </veui-select>
            </veui-field>
            <veui-field
                name="clue_city"
                label="线索地域"
                searchable
                :rules="[{name: 'required', value: true, message: '请选择线索地域'}]"
            >
                <veui-select
                    v-model="formData.clue_city"
                    data-stat-ignore
                    clearable
                    multiple
                    placeholder="请选择线索地域"
                >
                    <veui-option
                        v-for="(item,index) in regionOption"
                        :key="index"
                        :value="item.value"
                        :label="item.text"
                    />
                </veui-select>
            </veui-field>
            <veui-field
                name="day_range"
                label="线索时效"
                :rules="[{name: 'required', value: true, message: '请选择线索时效'}]"
            >
                <veui-select
                    v-model="formData.day_range"
                    data-stat-ignore
                    clearable
                    placeholder="请选择线索时效"
                >
                    <veui-option
                        v-for="(item,index) in timeOption"
                        :key="index"
                        :value="item.value"
                        :label="item.text"
                    />
                </veui-select>
            </veui-field>
            <veui-field
                name="clue_count"
                label="选购线索"
                :rules="countRule"
            >
                <div class="goods-form-num">
                    <div class="goods-form-num-tip">
                        <span>¥15/条</span>
                        <veui-icon
                            ref="text"
                            class="goods-form-num-icon"
                            name="exclamation-circle"
                        />
                        <veui-tooltip
                            target="text"
                            ui="m"
                            position="right"
                        >
                            线索产品目前还在试运营售卖阶段，所有线索单价均为15元/条，后续会跟随产品功能迭代，分层调整线索单价，还请知悉。
                        </veui-tooltip>
                    </div>
                    <div class="goods-form-num-input">
                        <veui-number-input
                            v-model="formData.clue_count"
                            ui="m"
                            :disabled="countDisable"
                            placeholder="请输入选购线索个数"
                            style="width:300px"
                            @change="handleInput"
                        />
                    </div>
                    <div v-if="!formData.clue_count || formData.clue_count <= 50" class="goods-form-num-text">
                        您每次购买线索时最多可购买50条
                    </div>
                </div>

            </veui-field>
            <veui-field
                name="isAgree"
                label=""
                :rules="[{name: 'required', value: true, message: '请阅读并勾选协议'}]"
            >
                <veui-checkbox
                    v-model="formData.isAgree"
                    :false-value="null"
                >
                    我已阅读并同意<span class="goods-form-rule" @click.stop="openRule">《{{ agreementInfo.name }}》</span>
                </veui-checkbox>
            </veui-field>
        </veui-form>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 线索包购买
 * @author
*/

import {
    Form,
    Field,
    Select,
    Option,
    Checkbox,
    Tooltip,
    Icon,
    NumberInput
} from 'veui';
import isBoolean from 'lodash/isBoolean';
import bendSDK from '@baidu/bend-plugin-sdk';
import 'veui-theme-dls-icons/exclamation-circle';
const url = {
    clueQuerySelect: 'law:/themis/law/commodity/clue_queryselect',
    cluePredispatch: 'law:/themis/law/commodity/clue_predispatch'
};
export default {
    name: 'goodsForm',
    props: {
        doaminOption: {
            'type': Array,
            'default': () => []
        },
        regionOption: {
            'type': Array,
            'default': () => []
        },
        timeOption: {
            'type': Array,
            'default': () => []
        },
        agreementInfo: {
            'type': Object,
            'default': () => {}
        },
        goodsList: {
            'type': Object,
            'default': () => {}
        },
        goodsForm: {
            'type': Object,
            'default': () => {}
        },
        goodsOrder: {
            'type': Object,
            'default': () => {}
        }
    },
    data() {
        return {
            countRule: [
                {
                    name: 'required',
                    value: true,
                    message: '请输入线索数量',
                    triggers: 'change'
                }
            ],
            validators: [
                {
                    fields: ['clue_count'],
                    validate(value) {
                        return new Promise(resolve => {
                            let res;
                            if (value > 50) {
                                res = {
                                    clue_count: '您每次购买线索时最多可购买50条'
                                };
                            }
                            return resolve(res);
                        });
                    },
                    triggers: ['change']
                }
            ]
        };
    },
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-select': Select,
        'veui-option': Option,
        'veui-checkbox': Checkbox,
        'veui-tooltip': Tooltip,
        'veui-icon': Icon,
        'veui-number-input': NumberInput
    },
    created() {},
    computed: {
        countDisable() {
            return !(this.formData.clue_territory && this.formData.clue_city && this.formData.day_range);
        },
        formData() {
            return this.goodsForm;
        }
    },
    methods: {
        sumbitForm() {
            this.$refs.culeForm.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    this.postData();
                }
                else {
                    const toast = {
                        content: '请完成必填选项',
                        duration: 3
                    };
                    this.$Message.info(toast);
                    this.$emit('nextStep', false);
                }
            });
        },
        postData() {
            const postParams = {
                clue_territory: this.formData.clue_territory.join(),
                clue_city: this.formData.clue_city.join(),
                day_range: this.formData.day_range,
                clue_count: this.formData.clue_count,
                refer: 'lvlin_b',
                midplat_agreement_id: this.agreementInfo.id,
                midplat_agreement_version: 100
            };
            this.$http.post(url.cluePredispatch, {
                ...postParams,
                params: JSON.stringify(postParams)
            }).then(resp => {
                const data = resp?.data?.data;
                if (data) {
                    data.clue_city = data.clue_city.join();
                    data.clue_territory = data.clue_territory.join();
                    this.$emit('setGoodsFn', 'goodsOrder', data);
                    this.$emit('nextStep', true);
                }
                else if (data.errno === 91001) {
                    this.$Message.error('当前筛选条件下无可购买的线索');
                    this.$emit('nextStep', false);
                }
                else {
                    this.$emit('nextStep', false);
                }
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.$emit('nextStep', false);
            });
        },
        handleInput(e) {
            this.$emit('setGoodsFn', 'goodsForm', this.formData);
        },
        openRule() {
            window.open(this.agreementInfo.url);
        }
    }
};
</script>

<style scoped lang="stylus">
.goods-form {
    .goods-form-num {
        display: block;
        &-tip {
            height: 32px;
            color: #282C33;
            line-height: 32px;
        }
        &-input {
            margin-top: 8px;
        }
        &-text {
            margin-top: 8px;
            color: #848B99;
        }
        &-icon {
            font-size: 14px;
            width: 14px;
            height: 14px;
            color: #848B99;
        }
    }
    /deep/ .veui-field-label {
        width: calc(5em + 6px);
    }
    .veui-field-no-label {
        margin-left 12px
    }
    .goods-form-rule {
        color: #0052CC;
    }
    /deep/ .veui-select-options[ui~=m] {
        max-height: auto;
    }
}
</style>
